<template>
    <div class="nav">
        <ul>
            <li v-if="tenantHasScreeningAccess">
                <router-link to="/tenant-screening">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16.016" height="19.969" viewBox="0 0 32.031 39.938">
                          <path class="fill-dark-grey" d="M114.584,492.6L102,505.161l-4.586-4.579a2,2,0,0,0-2.828,2.824l6,5.991a2,2,0,0,0,2.828,0L114,498.827v10.516a5.989,5.989,0,0,1-3.023,5.2L102,519.663l-8.976-5.122a5.991,5.991,0,0,1-3.024-5.2v-19.8a47.968,47.968,0,0,1,25.45.393,2,2,0,1,0,1.1-3.842,52.1,52.1,0,0,0-29.1,0A2,2,0,0,0,86,488.016v21.327a9.981,9.981,0,0,0,5.038,8.664l9.97,5.691a2,2,0,0,0,1.984,0l9.968-5.691a9.98,9.98,0,0,0,5.04-8.666V494.007A2,2,0,0,0,114.584,492.6Z" transform="translate(-86 -484.031)"/>
                        </svg>
                    </div>
                    {{ $t('sidebar.nav.myscreening') }}
                </router-link>
            </li>
<!--            <li>-->
<!--                <router-link to="/invitations">-->
<!--                    <div class="icon">-->
<!--                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 32 40">-->
<!--                          <path class="fill-dark-grey" d="M106,406a4,4,0,1,1-4-4A4,4,0,0,1,106,406Zm10,14.024H88a2,2,0,0,1-2-2v-24a2,2,0,1,1,4,0v22h24v-20H96a2,2,0,0,1-2-2v-6a8,8,0,0,1,16,0,2,2,0,0,1-4,0,4,4,0,0,0-8,0v4h18a2,2,0,0,1,2,2v24A2,2,0,0,1,116,420.024Z" transform="translate(-86 -380.031)"/>-->
<!--                        </svg>-->

<!--                    </div>-->
<!--                    {{ $t('sidebar.nav.permissions') }}-->
<!--                </router-link>-->
<!--            </li>-->
            <li>
                <router-link :to="{name: 'contracts'}" v-if="getTenantAccess === 'contract' || getTenantAccess === 'both'">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 32 40">
                          <path id="Contracts" class="fill-dark-grey" d="M96,612a2,2,0,0,1,0-4h8a2,2,0,1,1,0,4H96Zm0-16a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4H96Zm0,8a2,2,0,0,1,0-4h12a2,2,0,0,1,0,4H96Zm-6-18v34a2,2,0,0,1-4,0V584a2,2,0,0,1,2-2h20a2,2,0,0,1,1.415.586l8,8A2,2,0,0,1,118,592v28a2,2,0,0,1-2,2H96a2,2,0,0,1,0-4h18V592.827L107.174,586H90Z" transform="translate(-86 -582)"/>
                        </svg>
                    </div>
                    {{ $t('sidebar.nav.contracts') }}
                </router-link>
            </li>
            <li>
                <router-link  v-if="tenantHasScreeningAccess" to="/my-profile">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17.984" height="18" viewBox="0 0 35.969 36">
                          <path class="fill-dark-grey" d="M102,297a4,4,0,1,0-4-4A4,4,0,0,0,102,297Zm5.04,2.211,2.02,2.02,7.523,2.3a2,2,0,0,1,1.393,1.619l2,13.556a2,2,0,0,1-1.686,2.271A2.038,2.038,0,0,1,118,321H86.01a2,2,0,0,1-1.98-2.29l1.992-13.554a2,2,0,0,1,1.224-1.562l6-2.446a2,2,0,0,1,1.508,3.7l-4.94,2.014L88.324,317H115.68l-1.48-10.012-6.79-2.077a1.987,1.987,0,0,1-.828-0.5l-3.488-3.488a8,8,0,1,1,3.944-1.712h0Z" transform="translate(-84 -285)"/>
                        </svg>
                    </div>
                    {{ $t('sidebar.nav.myprofile') }}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapGetters([
                'tenantHasScreeningAccess',
                'getTenantAccess'
            ])
        },
        name: "TenantNavigation",
    }
</script>

<style scoped>

</style>
